module.exports = __webpack_public_path__ + "img/feature-shape-1.5420bb84.png";